import type { ServiceDocument } from '@bharat-consultancy/shared';

export function DocumentChecklist({ documents }: { documents: ServiceDocument[] }) {
  if (documents.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {documents.map((doc) => (
        <div key={doc.id} className="flex items-start gap-3 rounded border border-line bg-white p-3">
          <span className="mt-0.5 text-ledger-green">📄</span>
          <div>
            <p className="text-sm font-medium text-ink">{doc.docName}</p>
            <p className="text-xs text-ink/50">{doc.isMandatory ? 'Required' : 'Optional'}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
